import React, { useState } from "react";

export function Modal({ open, onClose, title, children, size = "md" }) {
    if (!open) return null;
    const sizes = { sm: "max-w-md", md: "max-w-lg", lg: "max-w-2xl", xl: "max-w-4xl" };
    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm animate-fade-in" onClick={onClose}>
            <div data-testid="modal" className={`bg-white rounded-xl shadow-2xl w-full ${sizes[size]} max-h-[90vh] overflow-y-auto`} onClick={(e) => e.stopPropagation()}>
                <div className="px-6 py-4 border-b border-slate-200 flex items-center justify-between sticky top-0 bg-white z-10">
                    <h3 className="font-display text-lg font-bold text-slate-900">{title}</h3>
                    <button onClick={onClose} className="text-slate-400 hover:text-slate-700" data-testid="modal-close">✕</button>
                </div>
                <div className="p-6">{children}</div>
            </div>
        </div>
    );
}

export function useModal() {
    const [open, setOpen] = useState(false);
    return { open, openModal: () => setOpen(true), closeModal: () => setOpen(false) };
}
